import { Home, Users, LayoutGrid, Layers, UserCircle } from 'lucide-react';

interface BottomNavProps {
  activeTab: 'home' | 'athletes' | 'hub' | 'groups' | 'profile';
  onTabChange: (tab: 'home' | 'athletes' | 'hub' | 'groups' | 'profile') => void;
}

export const BottomNav: React.FC<BottomNavProps> = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'home' as const, icon: Home, label: 'Главная' },
    { id: 'athletes' as const, icon: Users, label: 'Спортсмены' },
    { id: 'hub' as const, icon: LayoutGrid, label: 'Штаб' },
    { id: 'groups' as const, icon: Layers, label: 'Группы' },
    { id: 'profile' as const, icon: UserCircle, label: 'Профиль' },
  ];

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 h-14 border-t pb-safe z-30"
      style={{
        backgroundColor: 'var(--nav-bar-bg)',
        borderTopColor: 'var(--separator)',
      }}
    >
      <div className="flex items-center justify-around h-full relative">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          const isHub = tab.id === 'hub';
          const Icon = tab.icon;

          if (isHub) {
            return (
              <button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                className="flex flex-col items-center justify-center gap-1 relative"
              >
                {/* Elevated center button */}
                <div
                  className="absolute -top-6 w-12 h-12 rounded-full flex items-center justify-center shadow-lg"
                  style={{ backgroundColor: 'var(--accent)' }}
                >
                  <Icon size={32} color="white" strokeWidth={2} />
                </div>
                {/* Label below */}
                <span
                  className="text-[10px] font-medium mt-8"
                  style={{ color: 'var(--accent)' }}
                >
                  {tab.label}
                </span>
              </button>
            );
          }

          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className="flex flex-col items-center justify-center gap-1 min-w-[60px]"
            >
              {isActive ? (
                <Icon
                  size={24}
                  style={{ color: 'var(--accent)' }}
                  fill="currentColor"
                  strokeWidth={0}
                />
              ) : (
                <Icon size={24} style={{ color: 'var(--text-hint)' }} strokeWidth={2} />
              )}
              <span
                className="text-[10px] font-medium"
                style={{ color: isActive ? 'var(--accent)' : 'var(--text-hint)' }}
              >
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
